// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__IiC+0","subtitle":"PageNotFound_subtitle__W12JK","emoji":"PageNotFound_emoji__5Ny-+"};